<template>
  <Teleport to="body">
    <div class="modalBg modalHeight z-[2200] w-full flex items-center justify-center mobOnly:px-12" @click.stop>
      <div class="bg-lightest w-full max-w-556 p-16 desk:p-32 shadow-xl relative z-modalsContent">
        <div class="type-headline-base mb-16">
          {{ $t('mediaBank.terms.title') }}
        </div>

        <div class="type-sm text-text-subtle mb-24 leading-relaxed [&_a]:underline [&_a]:text-text-base hover:[&_a]:no-underline" v-html="$t('mediaBank.terms.body')" />

        <label class="flex items-start gap-12 cursor-pointer mb-24">
          <input
            v-model="accepted"
            type="checkbox"
            class="mt-2 shrink-0"
          >
          <span class="type-sm">{{ $t('mediaBank.terms.checkbox') }}</span>
        </label>

        <div class="flex flex-row items-center justify-end gap-16">
          <button
            class="btn btn--secondary"
            @click="$emit('cancel')"
          >
            {{ $t('mediaBank.terms.cancel') }}
          </button>
          <button
            class="btn"
            :disabled="!accepted"
            @click="onAccept"
          >
            {{ $t('mediaBank.terms.accept') }}
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
const { $t } = useNuxtApp();

const accepted = ref(false);

const emit = defineEmits<{
  (e: 'accept'): void;
  (e: 'cancel'): void;
}>();

const onAccept = () => {
  if (accepted.value) {
    emit('accept');
  }
};
</script>
